import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import bootstrapStyles from './grid.min.module.css';
import styles from './grid.module.scss';
import { applyClasses, applyProps } from '../shared/js';
import { applyBootstrapClasses } from './apply-bootstrap-classes';
import Row from './Row';
import Column from './Column';

const Grid = ({ children, ...props }) => {
  const bootstrapClasses = applyBootstrapClasses(props, bootstrapStyles);
  const classes = applyClasses(props, styles);
  return (
    <div
      className={cn(
        bootstrapStyles.container,
        // eslint-disable-next-line react/prop-types
        props.className,
        classes,
        bootstrapClasses
      )}
      {...applyProps(props)}
    >
      {children}
    </div>
  );
};

Grid.propTypes = {
  /** The Grid's rows */
  children: PropTypes.any,
  /** Creates a full-width container above the sm breakpoint. Equivalent to using .container-sm */
  containerSm: PropTypes.bool,
  /** Creates a full-width container above the md breakpoint. Equivalent to using .container-md */
  containerMd: PropTypes.bool,
  /** Creates a full-width container above the lg breakpoint. Equivalent to using .container-lg */
  containerLg: PropTypes.bool,
  /** Creates a full-width container above the xl breakpoint. Equivalent to using .container-xl */
  containerXl: PropTypes.bool,
  /** Creates a narrow container whose max-width is 900px */
  narrow: PropTypes.bool,
};

Grid.defaultProps = {
  children: undefined,
};

Grid.Row = Row;
Grid.Column = Column;
export default Grid;
